<template>
     <div id="bankiemsoat" >

<div class="group" style="padding-left: 10px;">
    <div class="contentNew">

        <table style="width: 100%;float: left;">
            <tr>
                <td colspan="2" style="text-align: center;font-size: 21px; text-transform: uppercase;">{{currentLanguage.header_text_congTy_banKiemSoat}}</td>
            </tr>
            <tr style="background: #c3f0f7;">
                <td style="width: 30%;text-align: center;text-transform: uppercase;font-weight: bold;">{{currentLanguage.body_text_congty_hdqt_HOTEN}}</td>
                <td style="text-align: center;text-transform: uppercase;font-weight: bold;">{{currentLanguage.body_text_congty_hdqt_CHUCVU}}</td>
            </tr>
            <tr style="border-bottom: 1px solid #D7D7D7;">
                <td style="width: 30%;">
                    <span class="hoten" style="float: left;">
                    {{currentLanguage.body_text_congty_hdh_tnt}}
                    </span>
                    <div style="width: 150px;border: 1px solid;float: right;">
                        <img src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1778233172515esQMF">
                    </div>
                </td>
                <td>
                    <span style="word-break: break-all;width: 100%;float: left;">{{currentLanguage.body_text_congty_hdqt_truongBanKiemSoat}}</span>
                    <span style="width: 100%;float: left;word-break: break-all;">Nghề nghiệp: Trưởng Phòng Khách hàng tổ chức, VCBS </span>
                    <span>Email: truongthanh103@gmail.com</span>
                </td>
            </tr>
             <tr style="border-bottom: 1px solid #D7D7D7;">
                <td style="width: 30%;">
                    <span class="hoten" style="float: left;">
                    Trương Công Thành
                    </span>
                    <div style="width: 150px;border: 1px solid;float: right;">
                        <img src="img/avatar/user.png">
                    </div>
                </td>
                <td>
                    <span style="word-break: break-all;width: 100%;float: left;">{{currentLanguage.body_text_congty_hdqt_thanhVienBanKiemSoat}} </span>
                    <!-- <span style="width: 100%;float: left;word-break: break-all;">Mrs Việt Nam 2018</span> -->
                    <span>Email: Tcthanh.ftu@gmail.com </span>
                </td>
            </tr>

            <tr style="border-bottom: 1px solid #D7D7D7;">
                <td style="width: 30%;">
                    <span class="hoten" style="float: left;">
                    {{currentLanguage.body_text_congty_hdh_tth}}
                    </span>
                    <div style="width: 150px;border: 1px solid;float: right;">
                        <img src="img/avatar/TTH.png">
                    </div>
                </td>
                <td>
                    <span style="word-break: break-all;width: 100%;float: left;">{{currentLanguage.body_text_congty_hdqt_thanhVienBanKiemSoat}} </span>
                    <!-- <span style="width: 100%;float: left;word-break: break-all;">Mrs Việt Nam 2018</span> -->
                    <span>Email: hienlinhgia@gmail.com </span>
                </td>
            </tr>

            
        </table>


    </div>
</div>

</div>
</template>
<script>

  import { languages } from "@/components/languages";


  export default {
    components: {
   
     
    },
    data() {
      return {
    
  
        currentLanguage: languages.vi,
        lang: "",   

      };
    },
    mounted() {
      this.lang = localStorage.getItem("languages") || "vi";
    },
    created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
    methods: {
      changeLanguage(lang) {
        this.currentLanguage = languages[lang];
        localStorage.setItem("languages", lang);
      window.location.reload();
      },
  

    },
  };
  </script>
